import React, { FC } from 'react'

export const Icon4: FC = () => (
  <svg
    width="155"
    height="123"
    viewBox="0 0 155 123"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M63.0728 102.898H16.6704C14.0081 102.898 11.8584 100.811 11.8584 98.2021V38.0828H106.291V70.182L110.123 67.5723C112.039 66.2661 114.251 65.5812 116.581 65.5812C116.779 65.5812 116.977 65.5812 117.148 65.6134V25.686C117.148 17.7601 110.528 11.3322 102.343 11.3322H99.1586V14.7403C99.1586 21.265 93.7439 26.5498 87.0161 26.5498H79.5507C72.8858 26.5498 67.4442 21.265 67.4442 14.7403V11.3322H50.6965V14.7403C50.6965 21.265 45.2189 26.5498 38.527 26.5498H31.0975C24.3697 26.5498 18.955 21.265 18.955 14.7403V11.3322H16.6704C7.99079 11.3322 0.966064 18.1841 0.966064 26.5656V98.2021C0.966064 106.651 7.99079 113.5 16.6704 113.5H70.0975C66.2389 111.314 63.5135 107.403 63.0728 102.898Z"
      fill="#262A44"
    />
    <path
      d="M40.4021 48.5188C40.4021 47.5192 39.5667 46.7031 38.5354 46.7031H23.4912C22.4513 46.7031 21.616 47.5192 21.616 48.5188V56.55C21.616 57.5538 22.4513 58.3633 23.4912 58.3633H38.5354C39.5667 58.3633 40.4021 57.5538 40.4021 56.55V48.5188Z"
      fill="#262A44"
    />
    <path
      d="M38.5354 82.6185H23.4912C22.4513 82.6185 21.616 83.4305 21.616 84.4334V92.4646C21.616 93.4651 22.4513 94.2778 23.4912 94.2778H38.5354C39.5667 94.2778 40.4021 93.4651 40.4021 92.4646V84.4334C40.4021 83.4305 39.5667 82.6185 38.5354 82.6185Z"
      fill="#262A44"
    />
    <path
      d="M96.4978 48.5173C96.4978 47.5177 95.6642 46.7014 94.6355 46.7014H79.5869C78.5494 46.7014 77.7158 47.5177 77.7158 48.5173V56.5484C77.7158 57.5523 78.5494 58.3618 79.5869 58.3618H94.6355C95.6642 58.3618 96.4978 57.5523 96.4978 56.5484V48.5173Z"
      fill="#262A44"
    />
    <path
      d="M68.4539 48.518C68.4539 47.5176 67.6191 46.7019 66.5843 46.7019H51.5407C50.5059 46.7019 49.6711 47.5176 49.6711 48.518V56.5486C49.6711 57.5524 50.5059 58.3613 51.5407 58.3613H66.5843C67.6191 58.3613 68.4539 57.5524 68.4539 56.5486V48.518Z"
      fill="#262A44"
    />
    <path
      d="M49.6614 84.4345V92.4587C49.6614 93.4687 50.5038 94.2842 51.5459 94.2842H63.009V91.7072C63.009 88.1842 64.3551 85.0209 66.5782 82.6056H51.5459C50.5038 82.6056 49.6614 83.4211 49.6614 84.4345Z"
      fill="#262A44"
    />
    <path
      d="M40.4021 66.4764C40.4021 65.4734 39.5667 64.6606 38.5354 64.6606H23.4912C22.4513 64.6606 21.616 65.4734 21.616 66.4764V74.5084C21.616 75.508 22.4513 76.3208 23.4912 76.3208H38.5354C39.5667 76.3208 40.4021 75.508 40.4021 74.5084V66.4764Z"
      fill="#262A44"
    />
    <path
      d="M94.6355 64.6598H79.5869C78.5494 64.6598 77.7158 65.4718 77.7158 66.4749V74.5068C77.7158 75.5064 78.5494 76.3193 79.5869 76.3193H94.6355C95.6642 76.3193 96.4978 75.5064 96.4978 74.5068V66.4749C96.4978 65.4718 95.6642 64.6598 94.6355 64.6598Z"
      fill="#262A44"
    />
    <path
      d="M68.4539 74.5069V66.4756C68.4539 65.4717 67.6191 64.6594 66.5843 64.6594H51.5407C50.5059 64.6594 49.6711 65.4717 49.6711 66.4756V74.5069C49.6711 75.5065 50.5059 76.3188 51.5407 76.3188H66.5843C67.6191 76.3188 68.4539 75.5065 68.4539 74.5069Z"
      fill="#262A44"
    />
    <path
      d="M31.0832 18.5669H38.5353C40.7035 18.5669 42.462 16.8627 42.462 14.7603V4.51035C42.462 2.40788 40.7035 0.703724 38.5353 0.703724H31.0832C28.915 0.703724 27.1565 2.40788 27.1565 4.51035V14.7603C27.1565 16.8627 28.915 18.5669 31.0832 18.5669Z"
      fill="#262A44"
    />
    <path
      d="M79.5765 18.5664H87.0322C89.1964 18.5664 90.9544 16.862 90.9544 14.7591V4.51016C90.9544 2.40725 89.1964 0.702797 87.0322 0.702797H79.5765C77.4123 0.702797 75.6543 2.40725 75.6543 4.51016V14.7591C75.6543 16.862 77.4123 18.5664 79.5765 18.5664Z"
      fill="#262A44"
    />
    <path
      d="M119.475 89.4489V76.5303C119.475 74.2746 116.85 72.9523 114.949 74.2492L103.852 81.8091C99.7431 84.6091 94.8463 86.1062 89.8318 86.1062H77.1781C74.0011 86.1062 71.4124 88.6104 71.4124 91.7002V101.579C71.4124 104.67 74.0011 107.17 77.1781 107.17H80.1469L82.6994 121.225C82.8623 122.115 83.6498 122.761 84.582 122.761H90.3749C91.5697 122.761 92.4748 121.723 92.2576 120.585L89.8318 107.17C94.8463 107.17 99.7431 108.671 103.852 111.467L114.949 119.027C116.85 120.323 119.475 119.002 119.475 116.746V103.832C123.349 103.567 126.417 100.465 126.417 96.6383C126.417 92.8127 123.349 89.7096 119.475 89.4489Z"
      fill="#4E97EA"
    />
    <path
      d="M144.416 74.2785C142.996 72.9216 140.719 72.944 139.317 74.3196C138.626 74.9986 138.285 75.8877 138.285 76.7732C138.285 77.6775 138.644 78.5827 139.354 79.267C144.103 83.7912 146.823 90.1304 146.823 96.6609C146.823 103.259 144.177 109.461 139.373 114.115C137.971 115.479 137.971 117.696 139.373 119.059C140.793 120.426 143.07 120.426 144.481 119.059C150.641 113.086 154.034 105.128 154.034 96.6609C154.034 88.2663 150.53 80.1114 144.416 74.2785Z"
      fill="#4E97EA"
    />
    <path
      d="M134.907 83.5242C133.491 82.1609 131.215 82.1609 129.808 83.5242C129.095 84.2094 128.748 85.1038 128.748 85.9991C128.748 86.8944 129.095 87.7897 129.808 88.4714C134.331 92.8646 134.331 100.459 129.808 104.849C128.401 106.212 128.401 108.427 129.808 109.796C131.215 111.16 133.491 111.16 134.907 109.796C138.526 106.279 140.527 101.615 140.527 96.6621C140.527 91.7078 138.526 87.0442 134.907 83.5242Z"
      fill="#4E97EA"
    />
  </svg>
)
